/**
 * TimeService.js
 * Provides a monotonic clock that is immune to system time changes (wall-clock jumps).
 */

let wallClockSyncPoint = Date.now();
let performanceSyncPoint = performance.now();

/**
 * Recalculates the sync point. 
 * Use this when the app loads or after a server time sync.
 */
export const syncTime = (serverTime = null) => {
    wallClockSyncPoint = serverTime ? new Date(serverTime).getTime() : Date.now();
    performanceSyncPoint = performance.now();
};

/**
 * Returns a monotonic "now" timestamp (ms).
 * This value will increase steadily even if the user changes their computer's system clock.
 */
export const getMonotonicNow = () => {
    const elapsedSinceSync = performance.now() - performanceSyncPoint;
    return wallClockSyncPoint + elapsedSinceSync;
};

/**
 * Returns a dayjs-like object or ISO string for the monotonic now.
 */
export const getMonotonicISO = () => {
    return new Date(getMonotonicNow()).toISOString();
};

// Auto-sync on import
syncTime();
